enum Mutations {
  SET_TIMEFRAME = 'setTimeframe',
  SET_PRINT_VIEW_KIND = 'setPrintViewKind',
  SET_TIMEFRAME_KIND = 'setTimeframeKind',
  SET_SHIFTPLAN = 'setShiftplan'
}

export default Mutations;
